<template>
	<section class="MobileWorkingHoursPage">
		<header class="Header">
			<Button class="header-buttons Button" @click="$router.back()">
				<ArrowLeftIcon size="24"/>
			</Button>
			<a class="Header-logo" href="/">
				<img src="/map/dist/skin/logo.svg" alt="Logo"/>
			</a>
			<span v-if="isLoading"
			      style="color: #777; font-size: 13px; position: absolute; display: flex; justify-content: center; align-items: center; left: 50%; top: 5px; margin-left: -15px; background: #fff; box-shadow: 0 2px 5px rgba(0,0,0,0.5); border-radius: 9999px; width: 30px; height: 30px;">
				<LoadingIndicator style="height: 16px;"/>
			</span>
		</header>
		<div class="sub-header">
			URENREGISTRATIE
		</div>
		<div class="month-selector">
			<span>Gewerkt: {{timeWorkedSelectedMonth}}</span>
			<select v-model="selectedMonth" @change="getWorkingHoursForSelectedMonth">
				<option v-for="month in months" :value="month.value">{{month.label}}</option>
			</select>
		</div>
		<main>
			<div class="working-hours-list">
				<span v-if="workingHours.length === 0" class="no-hours-label">
					Geen uren ingevoerd
				</span>
				<div class="hours-item" v-for="hours in workingHours" :key="hours.id">
						<div class="hours-header">
							<button class="unfold" @click="unfoldHours(hours.id)">
								<ChevronUpIcon v-if="unfoldedHoursId === hours.id" size="36"/>
								<ChevronDownIcon v-else size="36"/>
							</button>
							<div class="hours-sub-item date">
								<span class="hours-item-header">Datum</span>
								<span>{{reverseDate(hours.date)}}</span>
							</div>
							<div class="hours-sub-item time">
								<span class="hours-item-header">Gewerkt</span>
								<span>{{hours.timeWorked}}</span>
							</div>
							<div class="status" :class="hours.altered ? 'altered' : hours.approved ? 'approved' : ''">
								<CheckIcon v-if="hours.approved || hours.altered" size="24" color="#fffff"/>
							</div>
						</div>
						<div class="hours-body" v-if="unfoldedHoursId === hours.id">
							<div class="hours-sub-item start">
								<span class="hours-item-header">Begintijd</span>
								<span v-if="hours.start_time === null">-</span>
								<span v-else>{{hours.start_time.slice(0, -3)}}</span>
							</div>
							<div class="hours-sub-item end">
								<span class="hours-item-header">Eindtijd</span>
								<span v-if="hours.end_time === null">-</span>
								<span v-else>{{hours.end_time.slice(0, -3)}}</span>
							</div>
						</div>
				</div>
			</div>
			<Button class="cancel" @click="$router.back()">ANNULEER</Button>
		</main>
	</section>
</template>

<script>
import CheckIcon from "vue-feather-icons/icons/CheckIcon";
import ChevronDownIcon from "vue-feather-icons/icons/ChevronDownIcon";
import ChevronUpIcon from "vue-feather-icons/icons/ChevronUpIcon";
import {mapGetters, mapState} from "vuex";
import {client} from "../store";
import Button from "../components/Button.vue";
import SubmitAvailabilityZiekte from "../components/SubmitAvailability/Ziekte.vue";
import SubmitAvailabilityVerlof from "../components/SubmitAvailability/Verlof.vue";
import {ArrowLeftIcon} from 'vue-feather-icons';
import LoadingIndicator from "../components/LoadingIndicator.vue";

export default {
	components: {
		ChevronUpIcon,
		CheckIcon,
		ChevronDownIcon,
		LoadingIndicator,
		SubmitAvailabilityVerlof,
		SubmitAvailabilityZiekte,
		Button,
		ArrowLeftIcon
	},

	data() {
		return {
			selectedMonth: null,
			months: [],
			monthNames: [
				'Januari', 'Februari', 'Maart', 'April', 'Mei',
				'Juni', 'Juli', 'Augustus', 'September',
				'Oktober', 'November', 'December',
			],
			workingHours: [],
			timeWorkedSelectedMonth: '-',
			unfoldedHoursId: null
		}
	},

	computed: {
		...mapState({
			isLoading: "loading"
		}),
		...mapState('auth', {
			viewer: 'viewer',
		}),
		...mapGetters({
			allowedTo: 'auth/allowedTo',
		})
	},

	beforeMount() {
		this.initMonthFilter();
		this.getWorkingHoursForSelectedMonth();
	},

	methods: {
		initMonthFilter() {
			const date = new Date();
			this.selectedMonth = date.getMonth() + 1 + '-' + date.getFullYear();

			// fill months with the last three months in format mm-yyyy
			for (let i = 0; i < 3; i++) {
				this.months.push({label: this.monthNames[date.getMonth()], value: date.getMonth() + 1 + '-' + date.getFullYear()});
				date.setMonth(date.getMonth() - 1);
			}
		},


		getWorkingHoursForSelectedMonth() {
			client.query(`
				query($month: Int, $year: Int) {
					monthlyWorkingHoursCurrentUser(month: $month, year: $year) {
						id,
						date,
						start_time,
						end_time,
						approved,
						altered
					}
				}
			`, {
				month: parseInt(this.selectedMonth.split('-')[0], 10),
				year: parseInt(this.selectedMonth.split('-')[1], 10)
			}).then((result) => {
				this.unfoldedHoursId = null;
				this.parseWorkingHours(result.monthlyWorkingHoursCurrentUser);
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: 'app',
					title: 'Fout ophalen uren',
					type: 'error',
					text: `Uren konden niet opgehaald worden`,
				});
			});
		},

		parseWorkingHours(workingHours) {
			let totalMinutesWorked = 0;
			workingHours.map((workingHour) => {
				if(workingHour.start_time === null) {
					workingHour.timeWorked = '-';
					return;
				}
				const startTime = workingHour.start_time.split(':');
				const endTime = workingHour.end_time != null ? workingHour.end_time.split(':') : workingHour.start_time.split(':');
				const startMinutes = parseInt(startTime[0], 10) * 60 + parseInt(startTime[1], 10);
				const endMinutes = parseInt(endTime[0], 10) * 60 + parseInt(endTime[1], 10);
				let timeWorked = endMinutes - startMinutes;
				if(endTime[0] > 13 && timeWorked > 30) {
					timeWorked -= 30;
				}
				totalMinutesWorked += timeWorked;
				workingHour.timeWorked = Math.floor(timeWorked / 60) + ':' + this.zeroPad(timeWorked % 60);
			});
			this.workingHours = workingHours;

			if (totalMinutesWorked === 0) {
				this.timeWorkedSelectedMonth = '-';
				return;
			}
			this.timeWorkedSelectedMonth = Math.floor(totalMinutesWorked / 60) + ':' + this.zeroPad(totalMinutesWorked % 60);
		},

		getOfficeEmployees() {
			client.query(`
				query($userId: ID, $employeeStatus: String) {
					getUsersByEmployeeStatusForUserId(userId: $userId, employeeStatus: $employeeStatus) {
						phone,
						display_name
					}
				}
			`, {
				userId: this.viewer.id,
				employeeStatus: "Kantoor"
			}).then((result) => {
				this.officeEmployees = result.getUsersByEmployeeStatusForUserId;
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Fout ophalen kantoor medewerkers",
					type: "error",
					text: "Teamleider kon niet opgehaald worden",
				});
			});
		},
		reverseDate(date) {
			return date.split("-").reverse().join("-");
		},
		zeroPad(number) {
			return number.toString().padStart(2, '0');
		},
		unfoldHours(id) {
			if (this.unfoldedHoursId === id) {
				this.unfoldedHoursId = null;
			} else {
				this.unfoldedHoursId = id;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
main {
	height: calc(100% - 46px);
}

.sub-header {
	font-weight: 600;
	color: #FFFFFF;
	background-color: #1aae9f;
	text-align: center;
	padding: 12px;
}
.month-selector {
	border-bottom: 2px solid #eee;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 16px;
	gap: 8px;

	span {
		font-weight: 600;
	}

	select {
		width: 100%;
		border: 2px solid #c5ced6;
		background-color: #fff;
		padding: 6px;
		font-size: 1rem;
		border-radius: 4px;
	}

}


.working-hours-list {
	overflow-y: auto;
	max-height: calc(100% - 212px);

	.no-hours-label {
		text-align: center;
		display: block;
		padding: 16px;
	}

	.hours-item {
		font-size: 1rem;
		border-bottom: 2px solid #eeeeee;
		padding: 8px 0;

		.hours-header {
			display: flex;
			flex-direction: row;
			align-items: center;

			.unfold {
				width: 48px;
				height: 48px;
				background: #ffffff;
				border: none;
				color: #788896;
			}

			.status {
				width: 36px;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #ffffff;
				border-radius: 4px;

				&.approved {
					background-color: #1aae9f;
				}

				&.altered {
					background-color: #e8833a;
				}
			}
		}

		.hours-body {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-top: 8px;

			.hours-sub-item {
				&:nth-child(1) {
					margin-left: 48px;
				}
				&:nth-child(2) {
					margin-right: 48px;
				}
			}
		}

		.hours-sub-item {
			display: flex;
			width: calc(50% - 48px);
			flex-direction: column;
			justify-content: center;

			.hours-item-header {
				font-weight: 600;
			}
		}
	}
}

.Header {
	box-shadow: none;
	border-bottom: 2px solid #eee;
	display: grid;
	grid-template-columns: 1fr auto 1fr;
}

.MobileWorkingHoursPage {
	height: 100%;
}

.header-buttons {
	box-shadow: none;
	padding: 8px;
	max-width: 64px;
}

.Header-logo {
	margin-left: 0;
	display: flex;
	height: 100%;
	width: 200px;
	align-items: center;
	justify-content: center;
}

Button.cancel {
	font-weight: bold;
	color: #FFFFFF;
	background-color: #d3455b;
	border-radius: 4px;
	margin: 16px;
	text-align: center;
	width: calc(100% - 32px);
}
</style>
